
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationC as ObiLocationCElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-c.js';
 
 
 

 
 export const ObiLocationC = createComponent({
   react: React,
   tagName: 'obi-location-c',
   elementClass: ObiLocationCElement,
   events: {
     
   }
  });
 
 